<template>
  <div class="rectangle-shape d-grid">
    <div class="rectangle-shape-left-box"><div class="rect-right-shape w-100 position-relative" /></div>
    <div class="rectangle-shape-right-box"><div class="rect-left-shape w-100 position-relative" /></div>
  </div>
</template>
